import { Button, Result } from 'antd'

/// <reference types="vite-plugin-svgr/client" />
import Maintenance from '@/assets/illustrations/Maintenance.svg?react'
/// <reference types="vite-plugin-svgr/client" />
import ErrorIcon from '@/assets/illustrations/Do-Not-Proceed.svg?react'
import { useRouteError } from 'react-router-dom'
import { useEffect } from 'react'
import { sentryErrorAlert } from '@/configs/sentry'
const errorUpdateApp =
  'Failed to fetch dynamically imported module'.toLowerCase()
const errUpdate = 'Importing a module script failed'.toLowerCase()
const returnIndexHtml = 'valid JavaScript MIME type'.toLowerCase()
const inArr = [errorUpdateApp, errUpdate, returnIndexHtml]
export const ErrorPageRouter = () => {
  const error = useRouteError() as { message: string }
  const safeError = error.message || ''
  const isImportError = inArr.some((el) => {
    return safeError.toLowerCase().includes(el)
  })
  useEffect(() => {
    if (safeError && !isImportError) {
      sentryErrorAlert.errorAlert(new Error(safeError))
    }
  }, [isImportError, safeError])
  if (isImportError) {
    return (
      <div className="grid w-screen h-screen place-items-center">
        <Result
          icon={<Maintenance className="text-pallet3 h-[300px] w-[300px]" />}
          status="success"
          title="App Update Available"
          subTitle="A new version of the app is ready! Please refresh to load the updated version."
          extra={[
            <Button onClick={() => window.location.reload()} type="primary">
              Reload the page
            </Button>,
          ]}
        />
      </div>
    )
  }
  return (
    <div className="grid w-screen h-screen place-items-center">
      <Result
        icon={<ErrorIcon className="text-pallet3 h-[300px] w-[300px]" />}
        status="success"
        title="Oops! Something went wrong"
        subTitle="We're experiencing an unexpected error. Please try again later or contact the administrator if the issue persists."
        extra={[
          <Button
            target="_blank"
            href="https://api.whatsapp.com/send/?phone=6281188000823"
            type="primary"
          >
            Contact admin
          </Button>,
        ]}
      />
    </div>
  )
}
